import BaseEntity from "../base/BaseEntity";
import Tank from "../tank/Tank";
import {simpleDateTime, str2Date} from "../../filter/time";
import Filter from "../base/Filter";
import $ from "jquery";
import Vue from "vue";
import {startWith} from "../../filter/str";

let Status = {
	OK: "OK"
};
let StatusMap = {
	OK: {
		name: "正常",
		value: "OK",
		style: "info"
	}
}
let Type = {

	//网站内容
	"WEBSITE": "WEBSITE",
	//普通文章类型
	"ARTICLE": "ARTICLE"
};

let TypeMap = {
	WEBSITE: {
		name: "网站页面",
		value: "WEBSITE",
		style: "warning"
	},
	ARTICLE: {
		name: "普通文章",
		value: "ARTICLE",
		style: "primary"
	}
};

let TypeList = [];
for (let key in TypeMap) {
	TypeList.push(TypeMap[key]);
}


export default function Article() {

	//extend BaseEntity's Attributes.
	BaseEntity.call(this, arguments);

	this.title = null;
	//Array
	this.tags = [];
	//Tank Object
	this.poster = new Tank("image", false);
	this.video = new Tank("video", false);
	this.videoUrl = null;
	this.author = null;
	this.digest = null;
	this.content = null;
	this.hit = null;
	this.top = false;
	//Date
	this.releaseTime = new Date();
	this.special = false;
	this.status = null;
	this.type = Type.ARTICLE;


	this.addTankConstrain();

}


//extend BaseEntity
Article.prototype = new BaseEntity();
Article.prototype.constructor = Article;
Article.prototype.TAG = "article";
Article.prototype.TAGS = "articles";
Article.prototype.URL_PAGE = "/article/page";
Article.prototype.URL_DETAIL = "/article/detail/{id}";
Article.prototype.URL_CREATE = "/article/create";
Article.prototype.URL_EDIT = "/article/edit";
Article.prototype.URL_DEL = "/article/del/{id}";

Article.prototype.Status = Status;
Article.prototype.StatusMap = StatusMap;
Article.prototype.StatusList = Article.prototype.getStatusList();
Article.prototype.Type = Type;
Article.prototype.TypeMap = TypeMap;
Article.prototype.TypeList = Article.prototype.getTypeList();


Article.prototype.getFilters = function () {
	return [
		new Filter("SORT", "ID", "orderId"),
		new Filter("SORT", "点击量", "orderHit"),
		new Filter("SORT", "发布时间", "orderReleaseTime"),
		new Filter("SORT", "作者", "orderAuthor"),
		new Filter("INPUT", "标签", "tag"),
		new Filter("INPUT", "关键字", "keyword"),
		new Filter("INPUT", "标题", "title"),
		new Filter("SELECTION", "类型", "type", TypeList),
		new Filter("MULTI_SELECTION", "类型", "types", TypeList)
	];
};


Article.prototype.getDigest = function () {

	if (this.digest) {
		return this.digest;
	} else {
		return $("<div>" + this.content + "</div>").text();
	}
};

//We use this method to get the full js Object.
Article.prototype.render = function (obj) {

	BaseEntity.prototype.render.call(this, obj);


	this.renderEntity("releaseTime", Date);
	this.renderEntity("poster", Tank);
	this.renderEntity("video", Tank);


	this.addTankConstrain();

}
Article.prototype.addTankConstrain = function () {
	this.poster.maxSize = 1024 * 1024;
	this.poster.uploadHint = "图片大小不超过1M";
}
Article.prototype.getForm = function () {

	if (!this.videoUrl) {
		this.videoUrl = this.video.url;
	}

	let form = {
		title: this.title,
		tags: JSON.stringify(this.tags),
		posterCode: this.poster.code,
		videoCode: this.video.code,
		videoUrl: this.videoUrl,
		author: this.author,
		digest: this.digest,
		content: this.content,
		hit: this.hit,
		releaseTime: simpleDateTime(this.releaseTime),
		type: this.type
	};
	if (this.id) {
		form.id = this.id;
	}

	return form;

}


Article.prototype.validate = function () {
	//简单验证一下
	if (!this.title) {
		this.errorMessage = "标题必填！";
		return false;
	}

	if (!this.releaseTime) {
		this.errorMessage = "发布日期必填！";
		return false;
	}

	if (!this.author) {
		this.errorMessage = "作者必填！";
		return false;
	}
	if (this.type === Type.LINE_NEWS) {
		if (this.content) {
			if (!startWith(this.content, "http://") && !startWith(this.content, "https://")) {
				this.errorMessage = "一句话新闻链接格式错误！";
				return false;
			}
		}
	} else {
		if (!this.content) {
			this.errorMessage = "内容必填！";
			return false;
		}

	}

	return true;
}

Article.prototype.detailPageUrl = function () {

	let topic = Vue.store.state.route.meta.topic;
	if (topic) {
		return '/' + topic.location + '/article/detail/' + this.id;
	} else {
		return '/home/article/detail/' + this.id;
	}

}


Article.prototype.click = function () {

	let url = this.detailPageUrl();

	if (this.type === Type.LINE_NEWS) {
		if (startWith(this.content, "http://") || startWith(this.content, "https://")) {
			window.open(this.content);
		} else {
			console.error("未制定一句话新闻转跳地址，或者地址格式错误" + this.content);
		}
	} else {
		Vue.router.push(url);
	}


}



// WEBPACK FOOTER //
// ./src/common/model/article/Article.js